module.exports = __webpack_public_path__ + "img/add_big.439a1bb4.png";